// Vendors
import React from 'react';
import classnames from 'classnames';
import LoadingString from '../Loading/LoadingString/LoadingString';
import './button.scss';

function Button(_a) {
  var as = _a.as,
      to = _a.to,
      _b = _a.type,
      type = _b === void 0 ? 'button' : _b,
      onClick = _a.onClick,
      className = _a.className,
      children = _a.children,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      _d = _a.isLoading,
      isLoading = _d === void 0 ? false : _d;

  if (as && as === 'Link') {
    return React.createElement("a", {
      href: to,
      className: classnames('button', className) + (isLoading ? ' button-loading' : '')
    }, isLoading ? React.createElement(LoadingString, null, children) : children);
  }

  return React.createElement("button", {
    disabled: disabled,
    onClick: onClick,
    className: classnames('button', className) + (isLoading ? ' button-loading' : ''),
    type: type
  }, isLoading ? React.createElement(LoadingString, null, children) : children);
}

export default Button;